import React, { Component, Fragment, useEffect, useState, useCallback } from 'react';
import { Unity, useUnityContext } from "react-unity-webgl";
import MiddleCenterContainer from './containers/MiddleCenterContainer';
import { CircularProgressbar, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import "react-circular-progressbar/dist/styles.css";
import UnityFunctionsContainer from './UnityFunctionsContainer';

import {
    LocalUser,
    RemoteUser,
    useIsConnected,
    useJoin,
    useLocalMicrophoneTrack,
    usePublish,
    useRemoteUsers,
} from "agora-rtc-react";

function UnityContainer(props) {

    const [ commandJson, setCommandJson ] = useState();

    // Unity's initialization-related error will occur if you don't do this
    const [ isReady, setIsReady ] = useState(false);

    const UNITYOBJECT = {
        ReceiverObjName: "Browser Interaction",
        ReceiverFuncName: "UnityReceiveCommandResult",
    }

    const { unityProvider, isLoaded, loadingProgression, sendMessage, addEventListener, removeEventListener } = useUnityContext({
        loaderUrl: props.loaderUrl ? props.loaderUrl : "unity/landpurchasemode/LandPurchaseMode.loader.js",
        dataUrl: props.dataUrl ? props.dataUrl : "unity/landpurchasemode/LandPurchaseMode.data",
        frameworkUrl: props.frameworkUrl ? props.frameworkUrl : "unity/landpurchasemode/LandPurchaseMode.framework.js",
        codeUrl: props.codeUrl ? props.codeUrl : "unity/landpurchasemode/LandPurchaseMode.wasm",
    });


    // ################ AGORA - begins ################
    // Define state variables
    const [calling, setCalling] = useState(false);
    const isConnected = useIsConnected(); // Store the user's connection status
    const [appId, setAppId] = useState(process.env.REACT_APP_AGORA_APP_ID);
    const [channel, setChannel] = useState("");
    const [token, setToken] = useState(null);

    useJoin({appid: appId, channel: channel, token: token ? token : null}, calling);

    const [micOn, setMic] = useState(false);
    const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
    usePublish([localMicrophoneTrack]);

    const remoteUsers = useRemoteUsers();
    // ################ AGORA - ends ################

    var interval;

    useEffect(() => {

        interval = setInterval(() => checkUnityReady(), 1000);

        // Needs to handle event listener here instead of in UnityFunctionsContainer, otherwise it won't work on Safari!!!
        addEventListener("UnitySendCommandEx", handleUnitySendCommandEx);

        return () => {
            removeEventListener("UnitySendCommandEx", handleUnitySendCommandEx);
            clearInterval(interval);
        }

    }, [sendMessage, addEventListener, removeEventListener]);
    // ^ Putting [sendMessage, addEventListener, removeEventListener] is a must now in react-unity-webgl 9.6.0, otherwise UnityFunctionsContainer won't be able to sendMessage back to Unity properly.
    // Unity's initialization-related error will occur if you don't do this

    // Unity's initialization-related error will occur if you don't do this
    function checkUnityReady() {
        console.log('checkUnityReady...');

        clearInterval(interval);
        
        if (isLoaded) {
            setIsReady(true)
        }
    }

    function handleUnitySendCommandEx(json) {
        console.log(`handleUnitySendCommandEx json: ${json}`);

        const commandObject = JSON.parse(json);

        if (commandObject.command !== undefined) {
            switch(commandObject.command) {
                case "RequestTestResponse":             UnityRequestTestResponseEx(commandObject); break;
                case "RequestAgoraAction":              UnityRequestAgoraAction(commandObject); break;
                default:
                    console.warn('Unknown command: ' + commandObject.command);
                    props.sendMessage(UNITYOBJECT.ReceiverObjName, UNITYOBJECT.ReceiverFuncName, JSON.stringify({ command: commandObject.command, succeeded: false, errorCode: -1, error: 'Unknown command' }) ); //createResult(commandObject.command, false, "Unknown command", {})
                    break;
            }
        }
        else {
            console.log('Bad command');
        }
    }

    function UnityRequestTestResponseEx(commandObject) {
        console.log(`UnityRequestTestResponseEx ${JSON.stringify(commandObject)}`);

        let result = {
            succeeded: true, 
            command: commandObject.command, 
            randomNumber: Math.random(),
            errorCode: 0, 
            error: null,
        };

        console.log(`UnityRequestTestResponse result:${JSON.stringify(result)}`);

        sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveTestResponse", JSON.stringify(result));
    }

    function UnityRequestAgoraAction(commandObject) {
        if (commandObject.agoraCommand !== undefined) {
            switch(commandObject.agoraCommand) {
                case "AgoraSetChannel":     agoraSetChannel(commandObject); break;
                case "AgoraJoinChannel":    agoraJoinChannel(commandObject); break;
                case "AgoraLeaveChannel":   agoraLeaveChannel(commandObject); break;
                case "AgoraMicOn":          agoroMicOn(commandObject); break;
                case "AgoraMicOff":         agoroMicOff(commandObject); break;
            }
        }
    }

    function agoraSetChannel(commandObject) {
        console.log(`agoraSetChannel channel:${commandObject.channel}`);
        
        if (!commandObject.channel) {
            let result = { status: -1, succeeded: false, error: 'invalid parameter', agoraCommand: commandObject.agoraCommand, channel: commandObject.channel };
            sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveAgoraActionResponse", JSON.stringify(result));
            return;
        }

        setChannel(commandObject.channel);
        let result = { status: 0, succeeded: true, error: null, agoraCommand: commandObject.agoraCommand, channel: commandObject.channel };
        sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveAgoraActionResponse", JSON.stringify(result));
    }

    async function agoraJoinChannel(commandObject) {
        console.log(`agoraJoinChannel channel:${channel}`);
        
        setCalling(true);
        let result = { status: 0, succeeded: true, error: null, agoraCommand: commandObject.agoraCommand, channel: channel };
        sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveAgoraActionResponse", JSON.stringify(result));
    }

    function agoraLeaveChannel(commandObject) {
        console.log(`agoraLeaveChannel channel:${channel}`);
        
        let result = { status: 0, succeeded: true, error: null, agoraCommand: commandObject.agoraCommand, channel: channel };
        setCalling(false);
        sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveAgoraActionResponse", JSON.stringify(result));
    }

    function agoroMicOn(commandObject) {
        console.log(`agoroMicOn channel:${channel}`);
        
        let result = { status: 0, succeeded: true, error: null, agoraCommand: commandObject.agoraCommand, channel: channel };
        setMic(true); //setMic(a => !a); //
        sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveAgoraActionResponse", JSON.stringify(result));
    }

    function agoroMicOff(commandObject) {
        console.log(`agoroMicOff channel:${channel}`);
        
        let result = { status: 0, succeeded: true, error: null, agoraCommand: commandObject.agoraCommand, channel: channel };
        setMic(false); //setMic(a => !a); //
        sendMessage(UNITYOBJECT.ReceiverObjName, "UnityReceiveAgoraActionResponse", JSON.stringify(result));
    }

    
    return (
        <Fragment>
            <div>{ commandJson }</div>
            {
                isLoaded ?
                    null
                :
                    <MiddleCenterContainer style={{ backgroundColor: '#1b2e4e' }}>
                        <div style={{ width: 300, height: 300 }}>
                            <CircularProgressbarWithChildren
                                value={loadingProgression * 100}
                                //text={`${loadingProgression * 100}%`}
                                strokeWidth={3}
                                styles={{
                                    // Customize the root svg element
                                    root: {},
                                    // Customize the path, i.e. the "completed progress"
                                    path: {
                                        // Path color
                                        stroke: `#efefef`,
                                        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                        strokeLinecap: 'round', // 'butt',
                                        // Customize transition animation
                                        transition: 'stroke-dashoffset 0.1s ease 0s',
                                        // Rotate the path
                                        transform: 'rotate(0.0turn)',
                                        transformOrigin: 'center center',
                                    },
                                    // Customize the circle behind the path, i.e. the "total progress"
                                    trail: {
                                        // Trail color
                                        stroke: '#e6ffff',
                                        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                        strokeLinecap: 'round', // 'butt',
                                        // Rotate the trail
                                        transform: 'rotate(0.0turn)',
                                        transformOrigin: 'center center',
                                    },
                                    // Customize the text
                                    text: {
                                        // Text color
                                        fill: 'rgba(100, 100, 100, 1)',
                                        // Text size
                                        fontSize: '12px',
                                        dominantBaseline: 'middle',
                                        textAnchor: 'middle',
                                    },
                                    // Customize background - only used when the `background` prop is true
                                    background: {
                                        fill: '#3e98c7',
                                    },
                                }}
                            >
                                <img
                                    style={{ width: 100, marginTop: -5 }}
                                    src="logo192.png"
                                    alt="PAT Meta Logo"
                                />
                                <div style={{ fontFamily: 'verdana', fontSize: '26px', marginTop: 5, color: '#efefef' }}>
                                    <strong>{Math.round(loadingProgression * 100)}%</strong>
                                </div>
                            </CircularProgressbarWithChildren>
                        </div>
                        
                    </MiddleCenterContainer>
            }

            <Unity 
                style={{ 
                    width: props.width ? props.width : '100%', 
                    height: props.height ? props.height : '100%',
                    visibility: isLoaded ? "visible" : "hidden"
                }}
                unityProvider={unityProvider} 
            />
            { isLoaded && isReady ? <UnityFunctionsContainer sendMessage={sendMessage} addEventListener={addEventListener} removeEventListener={removeEventListener} isUnityLoaded={isLoaded} /> : null }
            {
                isConnected ?
                    <div>
                        {/*<div>channel: {channel} micOn: {micOn ? "MIC ON" : "MIC OFF"} calling: {calling ? "true" : "false"}</div>*/}
                        <div className="user">
                            <LocalUser
                                audioTrack={localMicrophoneTrack}
                                micOn={micOn}
                                cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg"
                            >
                                <div className="user-name">You</div>
                            </LocalUser>
                        </div>
                        {remoteUsers.map((user) => (
                            <div className="user" key={user.uid}>
                                <RemoteUser cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg" user={user}>
                                <div className="user-name">{user.uid}</div>
                                </RemoteUser>
                            </div>
                        ))}
                    </div>
                :
                    null
            }
        </Fragment>
    );
}

export default UnityContainer;
